import * as msgConfig from '../../assets/resource/config.json';
import { Configuracao } from '../modelo/configuracao';
import { environment } from '../../environments/environment';

export class Config {
    static getConfiguracao = (chave: string): string => {
        var mensagens: Configuracao[] = <any>msgConfig;
        return mensagens.find(w => w.chave == chave).valor;
    }

    // static SERVIDOR: string = Config.getConfiguracao("HOST");
    static SERVIDOR: string = environment.urlSite;
    static PORTAL_WS: string = "/ws-finiportalbf";
    static ENDERECO_WS: string = "/ws-finienderecobf";
    static SEGUNDAVIACARNE_WS: string = "/ws-finisegundaviacarnebf";
    static COPIACONTRATO_WS: string = "/ws-finicopiacontratobf";
    static EXTRATOCONTRATO_WS: string = "/ws-finiextratocontratobf";
    static LIQUIDACAOANTECIPADA_WS: string = "/ws-finiliquidacaoantecipadabf";
    static DEBITOAUTOMATICO_WS: string = "/ws-finidebitoautomaticobf";

    // API Orquestradora
    static ORQUESTRADORA: string = "https://api-adqemp.apps.arohoadqemppi.arocorpp.bradesco.com.br/orquestrador-consulta-documentos";
    static ORQUESTRADORA_CONSULTA_ID: string = Config.ORQUESTRADORA + "/v1/download";
    static ORQUESTRADORA_CONSULTA_DATA_BASE: string = Config.ORQUESTRADORA_CONSULTA_ID + "?dataBase=";

    static LOGIN_PATH: string = Config.SERVIDOR + Config.PORTAL_WS + "/portalLoginController";
    static NOVO_LOGIN_PATH: string = Config.SERVIDOR + Config.PORTAL_WS + "/portalNovoLoginController";
    static CONFIG_VISUAL_PATH: string = Config.SERVIDOR + Config.PORTAL_WS + "/configuracaoVisualController";
    static ENDERECO_PATH: string = Config.SERVIDOR + Config.ENDERECO_WS + "/enderecoController";
    static SEGUNDAVIACARNE_PATH: string = Config.SERVIDOR + Config.SEGUNDAVIACARNE_WS + "/segundaViaCarneController";
    static COPIACONTRATO_PATH: string = Config.SERVIDOR + Config.COPIACONTRATO_WS + "/copiaContratoController";
    static EXTRATOCONTRATO_PATH: string = Config.SERVIDOR + Config.EXTRATOCONTRATO_WS + "/extratoContratoController";
    static LIQUIDACAOANTECIPADA_PATH: string = Config.SERVIDOR + Config.LIQUIDACAOANTECIPADA_WS + "/liquidacaoAntecipadaController";
    static DEBITOAUTOMATICO_PATH: string = Config.SERVIDOR + Config.DEBITOAUTOMATICO_WS + "/debitoAutomaticoController";

    static POPUP_100VW = "100vw";
    static POPUP_100FULL = "100%";
    static POPUP_50VW = "50vw";
    static POPUP_35VW = "35vw";
    static POPUP_50PERCENT = "50%";
    static POPUP_85PERCENT = "85%";
    static POPUP_65PERCENT = "65%";
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/config.ts